// extracted by mini-css-extract-plugin
export default {"commentActions":"GRme0PIZk1PqoGSu11ZX","likesCount":"olagMNK8YrvSr5quq7NQ","likesCountLiked":"Kp1XCQAG2Z36yd2YyotQ"};